import React, { Component } from 'react'
import Icon, { IconColor } from './Icon'

type RadioStateName = 'checked' | 'unchecked'
type RadioStates = Record<RadioStateName, RadioState>

interface RadioState {
  icon: string
  color: IconColor
}

interface RadioProps {
  name: string
  label: string
  checked: boolean
  onChange: (name: string) => void
}

export default class Radio extends Component<RadioProps> {
  states: RadioStates = {
    checked: {
      icon: 'checkbox-circle',
      color: 'dark'
    },
    unchecked: {
      icon: 'checkbox-blank-circle',
      color: 'light'
    }
  }

  constructor (props: RadioProps) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  get check () {
    return this.props.checked ? this.states.checked : this.states.unchecked
  }

  handleClick () {
    this.props.onChange(this.props.name)
  }

  render () {
    return (
      <div
        className="inline-flex items-end cursor-pointer mr-4"
        onClick={this.handleClick}>
        <Icon
          name={this.check.icon}
          size="large"
          color={this.check.color} />
        <div className="ml-2">{this.props.label}</div>
      </div>
    )
  }
}
